module.exports = __webpack_public_path__ + "img/LOGO.a476d92.png";